// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/assets/img//show.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/public/assets/img/hide.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.btn-outline-primary{
	color:#32879c ;
	border-color:#32879c;
}
.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{
	background-color:#32879c;
	color:#fff;
}
.hand_geture:hover{
    color: blue;
}
.bg-white{
	background-color:#fff;
}
.headBG {
box-sizing: border-box;
background: #FFFFFF;
border: 1px solid #358696;
}

.mainDiv{
	margin-top:80px;
}


.mainDiv__{
	margin-top:80px;
}

.widget{
	/* background: #FFFFFF; */
    /* box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11); */
    /* border-color: blue !important; */
}
.widgetIcon img{
	width:60px;height:60px;
}
.widgetIcon-32 img{
	width:32px;height:32px;
}
.titlebd_drive {
    font-size: 1.2em;
    /* color: #000; */
    color: rgb(98, 89, 89) !important;
    font-weight: 500;
    margin-bottom: 0px;
	/* text-align:center; */
    /* margin-bottom: 0; */
    /* padding-bottom: 0; */
    
}
.chartbox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
    min-height: 200px;
}
.tablebox{
	background: #FFFFFF;
    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);
    padding: 10px;
    color: #353535;
    /* font-size: 14px; */
    /* min-height: 250px; */
    min-height: 280px;
}
	h5, .h5 {
    font-size: 1.1rem !important;
}
p {
    line-height: 1rem !important;
}
small, .small {
    font-size: 80% !important;
}
	
table tr td {
	font-size:0.8em;
}
.accordion-button{
	font-size:0.5em;
}
.accordion-button:not(.collapsed){
	background-color:#e0e0e0;
	color:#222;
}
	
/* PageTwo */
.bt-graph {
    border-right: solid 1px #b5b5b5;
}






/* media queries start here */
@media screen and (max-width: 740px) {
.titlebg {
	font-size: 0.9em;
}
}
@media (max-width: 768px){
    .popover,.dropdown-menu {
    top: 20% !important;
    
}
}

/* @media screen and (max-width: 800px) {
    .mainDiv{
        margin-top: 130px;
    }
    } */

    /* @media only screen and  (max-width: 1069px) {
        .mainDiv__{
            margin-top: 170px;
        }
        } */


        @media only screen and  (max-width: 380px) {
            .mainDiv{
                margin-top: 170px;
            }
            }
        

        @media only screen and  (max-width: 768px) {
            .mainDiv__{
                margin-top: 130px;
            }
            }

            @media only screen and  (max-width: 380px) {
                .mainDiv__{
                    margin-top: 170px;
                }
                }
            

            @media only screen and  (max-width: 450px) {
                .widgetIcon_{
                    /* height: 50px;
                    width: 30px; */
                }
                }


/* @media only screen and  (max-width: 1053px) {
.mainDiv{
	margin-top: 170px;
}
} */

@media only screen and  (max-width: 768px) {
    .mainDiv{
        margin-top: 130px;
    }
    }
	
@media screen and (max-width: 480px) {
.topHeader h2{
	font-size: 22px;
    padding-right: 3rem;
}
	.titlebg {
		font-size: 0.9em;
	}
}

@media screen and (max-width: 320px) {
	.topHeader h2{
	font-size: 16px;
		padding-right: 0rem;
	}
}

.select_col_title {
	background: transparent; 
	padding: 0px !important;
	text-align: left;
	 margin-bottom:0px !important;
	color: #358696 !important;
	font-weight: 600;
	display: block;
  }
  .react-datepicker__input-container input[type="text"] {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
  }
  .top-filter {
    width: 100%;
    background: #fff;
    height: 35px;
    border: solid 1px #a5a5a5;
    border-radius: 3px;
    font-size: 14px;
    color: #353535;
    text-indent: 10px;
    margin-bottom: 12px;
}
.css-1r4vtzz {
    border-radius: 3px !important;
    font-size: 14px !important;
    color: #353535 !important;
    padding: 5px 5px !important;
    text-indent: 10px !important;
}
.css-1r4vtzz {
    width: 100% !important;
}
.submit_btn {
    color: #fff !important;
    width: 100%;
    margin-top: 23%;
    background: #32879c;
    border: #32879c;
}



.reset_btn {
    color: #fff !important;
    width: 100%;
    margin-top: 23%;
    background: #7b7878;
    border: silver;
}

@media screen and (max-width: 768px) {
    .submit_btn{
        margin-top: 2%;
    }
   
    .reset_btn{
        margin-top: 2%;
    }
    }
    .tablecontainer {
        height: 202px;
        overflow-y: scroll;
        width: 99.5%;
    }
    .btn-infotable {
        color: black;
        background-color: #fff;
        border-color: #32879c;
        
    }
    .hand_geture {
        cursor: pointer !important;
    }

    .filters-showhide {
        width: 100%;
        margin: 0 15px;
    }
    
    
    
    .filter-form {
        display: block;
        width: 100%;
        margin-top: -11px;
        background: #454545;
        position: relative;
        min-height: 20px;
        color: #000;
        height: 1px;
        position: relative;
    }
    .show-hide-button[aria-expanded="false"] {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center top #32879c;
        width: 50px !important;
        height: 25px !important;
        border-radius: 0px;
        border: none;
        margin-top: 2px;
       
       
    }
    
    .show-hide-button[aria-expanded="true"] {
        background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center top #32879c;
        width: 50px !important;
        height: 25px !important;
        border-radius: 0px;
        border: none;
        margin-top: 2px;
        
    }
    .FilterDiv {
        background: #e7e7e7;
        /* padding-top: 25px; */
        padding-bottom: 10px;
        margin-right: -5px;
        margin-left: -1px;
        margin-top: 2px;
        position: relative;
        /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */
    }
    .show-hide-button {
        font-size: 12px;
        color: #fff;
        border: none;
        outline: none;
        box-shadow: none !important;
        background: #245571;
        text-indent: 19px;
        width: 50px;
        height: 25px;
        z-index: 2;
       position: absolute;
       top: -1px;
       right: 19px;
    }

    /***************************/
    .chartHGT strong {
        position: absolute;
        top: 5px;
        right: 25px;
        /* border-radius: 6px; */
    }

    /* .chartHGT{
        border-radius: 6px;
    } */
    strong.align-top-chn{
        top: 35px;
    }
    /* .fixed-top {
        position: relative !important;
    } */
    strong#oldpz {
        top: 28px;
        right: 4px;
        z-index: 1;
    }


    .row.equal-cols {
        display: flex;
        flex-wrap: wrap;
    }

    .row.equal-cols:before,
    .row.equal-cols:after {
        display: block;
    }

    .row.equal-cols>[class*='col-'] {
        display: flex;
        flex-direction: column;
    }

    .row.equal-cols>[class*='col-']>* {
        flex: 1 1 auto;
    }

.new_drive_dashboard{
    background-color: #ecf1f4;
}

.drivediv{
    /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */
    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;
}

.widgetstyle{
    border: 1.5px solid #32879c;
    border-radius: 10px;
    height: 75px;
}

.drive_selection_box{
    border: 1px solid #e9eef4;
    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;
}

.drive_table_div{
    height: 40px;
    width: 100%;
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 4px;
    position: relative;
    border-radius: 6px;
    /* border: 1px solid #dcdbdb; */
}

.drive_span{
    font-weight: 600;
}

.dropdown_img{
    height: 28px;
    width: 47px;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
}

.dropdown_div{
    width: 100%;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    border-radius: 0 0 4px 4px;
    padding: 10px;
    background-color: #e7e7e7;
    border: 1px solid #dcdbdb;
}

.drive_graph{
    border-radius: 6px;
    height: 280px;
}

.kpi_value{
    font-weight: 600;
    /* font-size: 1rem !important; */
}

.box_title{
    /* background-color: #cdcfce; */
    background-color: #E0E0E0;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    color: #32879c !important;
    font-size: 1.1em !important;
    font-weight: 600 !important;
}

.kpi_text{
    font-size: 13px;
}

.raphael-group-GUjlfOCU{
    display: none !important;
}


.dropdownSelect {
    width: auto !important;
    height: 30px;
    font-size: 12px !important;
}

/* .form-select:focus {
    border-color: #358696;
    outline: 0;
    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);
    width: 30px;
} */


.table-container {
    height: 257px; /* Set the height of the table container */
    overflow-y: scroll; /* Add vertical scroll when content overflows */
    margin-bottom: 0;
    scrollbar-width: thin; 
  }
  
  .table {
    width: 100%; /* Ensure the table takes up the full width */
  }

.graph_two{
    min-height: 295px;
}

  
  
`, "",{"version":3,"sources":["webpack://./src/componets/Dashboard_Jupiter/Driveanalysis_Jupiter/Driveanalysis_Jupiter.css"],"names":[],"mappings":";AACA;CACC,cAAc;CACd,oBAAoB;AACrB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;AACA;IACI,WAAW;AACf;AACA;CACC,qBAAqB;AACtB;AACA;AACA,sBAAsB;AACtB,mBAAmB;AACnB,yBAAyB;AACzB;;AAEA;CACC,eAAe;AAChB;;;AAGA;CACC,eAAe;AAChB;;AAEA;CACC,yBAAyB;IACtB,kDAAkD;IAClD,mCAAmC;AACvC;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;CACC,UAAU,CAAC,WAAW;AACvB;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;CACrB,uBAAuB;IACpB,sBAAsB;IACtB,uBAAuB;;AAE3B;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,iBAAiB;AACrB;AACA;CACC,mBAAmB;IAChB,wCAAwC;IACxC,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,iBAAiB;AACrB;CACC;IACG,4BAA4B;AAChC;AACA;IACI,4BAA4B;AAChC;AACA;IACI,yBAAyB;AAC7B;;AAEA;CACC,eAAe;AAChB;AACA;CACC,eAAe;AAChB;AACA;CACC,wBAAwB;CACxB,UAAU;AACX;;AAEA,YAAY;AACZ;IACI,+BAA+B;AACnC;;;;;;;AAOA,6BAA6B;AAC7B;AACA;CACC,gBAAgB;AACjB;AACA;AACA;IACI;IACA,mBAAmB;;AAEvB;AACA;;AAEA;;;;OAIO;;IAEH;;;;WAIO;;;QAGH;YACI;gBACI,iBAAiB;YACrB;YACA;;;QAGJ;YACI;gBACI,iBAAiB;YACrB;YACA;;YAEA;gBACI;oBACI,iBAAiB;gBACrB;gBACA;;;YAGJ;gBACI;oBACI;kCACc;gBAClB;gBACA;;;AAGhB;;;;GAIG;;AAEH;IACI;QACI,iBAAiB;IACrB;IACA;;AAEJ;AACA;CACC,eAAe;IACZ,mBAAmB;AACvB;CACC;EACC,gBAAgB;CACjB;AACD;;AAEA;CACC;CACA,eAAe;EACd,mBAAmB;CACpB;AACD;;AAEA;CACC,uBAAuB;CACvB,uBAAuB;CACvB,gBAAgB;EACf,4BAA4B;CAC7B,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;EACb;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;IAC1B,yBAAyB;IACzB,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;;;AAIA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;IACA;IACA;QACI,aAAa;QACb,kBAAkB;QAClB,YAAY;IAChB;IACA;QACI,YAAY;QACZ,sBAAsB;QACtB,qBAAqB;;IAEzB;IACA;QACI,0BAA0B;IAC9B;;IAEA;QACI,WAAW;QACX,cAAc;IAClB;;;;IAIA;QACI,cAAc;QACd,WAAW;QACX,iBAAiB;QACjB,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,WAAW;QACX,kBAAkB;IACtB;IACA;QACI,gFAA0E;QAC1E,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,eAAe;;;IAGnB;;IAEA;QACI,gFAAyE;QACzE,sBAAsB;QACtB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,eAAe;;IAEnB;IACA;QACI,mBAAmB;QACnB,uBAAuB;QACvB,oBAAoB;QACpB,kBAAkB;QAClB,iBAAiB;QACjB,eAAe;QACf,kBAAkB;QAClB,iDAAiD;IACrD;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,aAAa;QACb,2BAA2B;QAC3B,mBAAmB;QACnB,iBAAiB;QACjB,WAAW;QACX,YAAY;QACZ,UAAU;OACX,kBAAkB;OAClB,SAAS;OACT,WAAW;IACd;;IAEA,4BAA4B;IAC5B;QACI,kBAAkB;QAClB,QAAQ;QACR,WAAW;QACX,wBAAwB;IAC5B;;IAEA;;OAEG;IACH;QACI,SAAS;IACb;IACA;;OAEG;IACH;QACI,SAAS;QACT,UAAU;QACV,UAAU;IACd;;;IAGA;QAGI,aAAa;QAGb,eAAe;IACnB;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QAGI,aAAa;QAGb,sBAAsB;IAC1B;;IAEA;QAGI,cAAc;IAClB;;AAEJ;IACI,yBAAyB;AAC7B;;AAEA;IACI,iEAAiE;IACjE,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,2CAA2C;IAC3C,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,wCAAwC;IACxC,0BAA0B;IAC1B,aAAa;IACb,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;IACI,sBAAsB;IACtB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;;;;;GAKG;;;AAGH;IACI,aAAa,EAAE,0CAA0C;IACzD,kBAAkB,EAAE,+CAA+C;IACnE,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,WAAW,EAAE,6CAA6C;EAC5D;;AAEF;IACI,iBAAiB;AACrB","sourcesContent":["\n.btn-outline-primary{\n\tcolor:#32879c ;\n\tborder-color:#32879c;\n}\n.btn-outline-primary:hover, .btn-outline-primary:focus, .btn-outline-primary:visited, .btn-outline-primary:active, .btn-check:checked+.btn, .btn.active, .btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active{\n\tbackground-color:#32879c;\n\tcolor:#fff;\n}\n.hand_geture:hover{\n    color: blue;\n}\n.bg-white{\n\tbackground-color:#fff;\n}\n.headBG {\nbox-sizing: border-box;\nbackground: #FFFFFF;\nborder: 1px solid #358696;\n}\n\n.mainDiv{\n\tmargin-top:80px;\n}\n\n\n.mainDiv__{\n\tmargin-top:80px;\n}\n\n.widget{\n\t/* background: #FFFFFF; */\n    /* box-shadow: 0px 0px 11px rgba(0, 0, 0, 0.11); */\n    /* border-color: blue !important; */\n}\n.widgetIcon img{\n\twidth:60px;height:60px;\n}\n.widgetIcon-32 img{\n\twidth:32px;height:32px;\n}\n.titlebd_drive {\n    font-size: 1.2em;\n    /* color: #000; */\n    color: rgb(98, 89, 89) !important;\n    font-weight: 500;\n    margin-bottom: 0px;\n\t/* text-align:center; */\n    /* margin-bottom: 0; */\n    /* padding-bottom: 0; */\n    \n}\n.chartbox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* font-size: 14px; */\n    min-height: 200px;\n}\n.tablebox{\n\tbackground: #FFFFFF;\n    box-shadow: 0px 0px 5px rgb(0 0 0 / 11%);\n    padding: 10px;\n    color: #353535;\n    /* font-size: 14px; */\n    /* min-height: 250px; */\n    min-height: 280px;\n}\n\th5, .h5 {\n    font-size: 1.1rem !important;\n}\np {\n    line-height: 1rem !important;\n}\nsmall, .small {\n    font-size: 80% !important;\n}\n\t\ntable tr td {\n\tfont-size:0.8em;\n}\n.accordion-button{\n\tfont-size:0.5em;\n}\n.accordion-button:not(.collapsed){\n\tbackground-color:#e0e0e0;\n\tcolor:#222;\n}\n\t\n/* PageTwo */\n.bt-graph {\n    border-right: solid 1px #b5b5b5;\n}\n\n\n\n\n\n\n/* media queries start here */\n@media screen and (max-width: 740px) {\n.titlebg {\n\tfont-size: 0.9em;\n}\n}\n@media (max-width: 768px){\n    .popover,.dropdown-menu {\n    top: 20% !important;\n    \n}\n}\n\n/* @media screen and (max-width: 800px) {\n    .mainDiv{\n        margin-top: 130px;\n    }\n    } */\n\n    /* @media only screen and  (max-width: 1069px) {\n        .mainDiv__{\n            margin-top: 170px;\n        }\n        } */\n\n\n        @media only screen and  (max-width: 380px) {\n            .mainDiv{\n                margin-top: 170px;\n            }\n            }\n        \n\n        @media only screen and  (max-width: 768px) {\n            .mainDiv__{\n                margin-top: 130px;\n            }\n            }\n\n            @media only screen and  (max-width: 380px) {\n                .mainDiv__{\n                    margin-top: 170px;\n                }\n                }\n            \n\n            @media only screen and  (max-width: 450px) {\n                .widgetIcon_{\n                    /* height: 50px;\n                    width: 30px; */\n                }\n                }\n\n\n/* @media only screen and  (max-width: 1053px) {\n.mainDiv{\n\tmargin-top: 170px;\n}\n} */\n\n@media only screen and  (max-width: 768px) {\n    .mainDiv{\n        margin-top: 130px;\n    }\n    }\n\t\n@media screen and (max-width: 480px) {\n.topHeader h2{\n\tfont-size: 22px;\n    padding-right: 3rem;\n}\n\t.titlebg {\n\t\tfont-size: 0.9em;\n\t}\n}\n\n@media screen and (max-width: 320px) {\n\t.topHeader h2{\n\tfont-size: 16px;\n\t\tpadding-right: 0rem;\n\t}\n}\n\n.select_col_title {\n\tbackground: transparent; \n\tpadding: 0px !important;\n\ttext-align: left;\n\t margin-bottom:0px !important;\n\tcolor: #358696 !important;\n\tfont-weight: 600;\n\tdisplay: block;\n  }\n  .react-datepicker__input-container input[type=\"text\"] {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n  }\n  .top-filter {\n    width: 100%;\n    background: #fff;\n    height: 35px;\n    border: solid 1px #a5a5a5;\n    border-radius: 3px;\n    font-size: 14px;\n    color: #353535;\n    text-indent: 10px;\n    margin-bottom: 12px;\n}\n.css-1r4vtzz {\n    border-radius: 3px !important;\n    font-size: 14px !important;\n    color: #353535 !important;\n    padding: 5px 5px !important;\n    text-indent: 10px !important;\n}\n.css-1r4vtzz {\n    width: 100% !important;\n}\n.submit_btn {\n    color: #fff !important;\n    width: 100%;\n    margin-top: 23%;\n    background: #32879c;\n    border: #32879c;\n}\n\n\n\n.reset_btn {\n    color: #fff !important;\n    width: 100%;\n    margin-top: 23%;\n    background: #7b7878;\n    border: silver;\n}\n\n@media screen and (max-width: 768px) {\n    .submit_btn{\n        margin-top: 2%;\n    }\n   \n    .reset_btn{\n        margin-top: 2%;\n    }\n    }\n    .tablecontainer {\n        height: 202px;\n        overflow-y: scroll;\n        width: 99.5%;\n    }\n    .btn-infotable {\n        color: black;\n        background-color: #fff;\n        border-color: #32879c;\n        \n    }\n    .hand_geture {\n        cursor: pointer !important;\n    }\n\n    .filters-showhide {\n        width: 100%;\n        margin: 0 15px;\n    }\n    \n    \n    \n    .filter-form {\n        display: block;\n        width: 100%;\n        margin-top: -11px;\n        background: #454545;\n        position: relative;\n        min-height: 20px;\n        color: #000;\n        height: 1px;\n        position: relative;\n    }\n    .show-hide-button[aria-expanded=\"false\"] {\n        background: url(/public/assets/img//show.png) no-repeat center top #32879c;\n        width: 50px !important;\n        height: 25px !important;\n        border-radius: 0px;\n        border: none;\n        margin-top: 2px;\n       \n       \n    }\n    \n    .show-hide-button[aria-expanded=\"true\"] {\n        background: url(/public/assets/img/hide.png) no-repeat center top #32879c;\n        width: 50px !important;\n        height: 25px !important;\n        border-radius: 0px;\n        border: none;\n        margin-top: 2px;\n        \n    }\n    .FilterDiv {\n        background: #e7e7e7;\n        /* padding-top: 25px; */\n        padding-bottom: 10px;\n        margin-right: -5px;\n        margin-left: -1px;\n        margin-top: 2px;\n        position: relative;\n        /* box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px; */\n    }\n    .show-hide-button {\n        font-size: 12px;\n        color: #fff;\n        border: none;\n        outline: none;\n        box-shadow: none !important;\n        background: #245571;\n        text-indent: 19px;\n        width: 50px;\n        height: 25px;\n        z-index: 2;\n       position: absolute;\n       top: -1px;\n       right: 19px;\n    }\n\n    /***************************/\n    .chartHGT strong {\n        position: absolute;\n        top: 5px;\n        right: 25px;\n        /* border-radius: 6px; */\n    }\n\n    /* .chartHGT{\n        border-radius: 6px;\n    } */\n    strong.align-top-chn{\n        top: 35px;\n    }\n    /* .fixed-top {\n        position: relative !important;\n    } */\n    strong#oldpz {\n        top: 28px;\n        right: 4px;\n        z-index: 1;\n    }\n\n\n    .row.equal-cols {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-flex-wrap: wrap;\n        -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n    }\n\n    .row.equal-cols:before,\n    .row.equal-cols:after {\n        display: block;\n    }\n\n    .row.equal-cols>[class*='col-'] {\n        display: -webkit-flex;\n        display: -ms-flexbox;\n        display: flex;\n        -webkit-flex-direction: column;\n        -ms-flex-direction: column;\n        flex-direction: column;\n    }\n\n    .row.equal-cols>[class*='col-']>* {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n    }\n\n.new_drive_dashboard{\n    background-color: #ecf1f4;\n}\n\n.drivediv{\n    /* box-shadow: 10px 10px 20px #babecc, -10px -10px 20px #ffffff */\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 6px;\n}\n\n.widgetstyle{\n    border: 1.5px solid #32879c;\n    border-radius: 10px;\n    height: 75px;\n}\n\n.drive_selection_box{\n    border: 1px solid #e9eef4;\n    box-shadow: rgba(0, 0, 0, 0.08) 0px 1px 1px 1px;\n}\n\n.drive_table_div{\n    height: 40px;\n    width: 100%;\n    background-color: #fff;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 1px 4px;\n    position: relative;\n    border-radius: 6px;\n    /* border: 1px solid #dcdbdb; */\n}\n\n.drive_span{\n    font-weight: 600;\n}\n\n.dropdown_img{\n    height: 28px;\n    width: 47px;\n    cursor: pointer;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.dropdown_div{\n    width: 100%;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 0 0 4px 4px;\n    padding: 10px;\n    background-color: #e7e7e7;\n    border: 1px solid #dcdbdb;\n}\n\n.drive_graph{\n    border-radius: 6px;\n    height: 280px;\n}\n\n.kpi_value{\n    font-weight: 600;\n    /* font-size: 1rem !important; */\n}\n\n.box_title{\n    /* background-color: #cdcfce; */\n    background-color: #E0E0E0;\n    border-radius: 5px;\n    display: flex;\n    justify-content: center;\n    color: #32879c !important;\n    font-size: 1.1em !important;\n    font-weight: 600 !important;\n}\n\n.kpi_text{\n    font-size: 13px;\n}\n\n.raphael-group-GUjlfOCU{\n    display: none !important;\n}\n\n\n.dropdownSelect {\n    width: auto !important;\n    height: 30px;\n    font-size: 12px !important;\n}\n\n/* .form-select:focus {\n    border-color: #358696;\n    outline: 0;\n    box-shadow: 0 0 0 0.25rem rgb(53 134 150 / 23%);\n    width: 30px;\n} */\n\n\n.table-container {\n    height: 257px; /* Set the height of the table container */\n    overflow-y: scroll; /* Add vertical scroll when content overflows */\n    margin-bottom: 0;\n    scrollbar-width: thin; \n  }\n  \n  .table {\n    width: 100%; /* Ensure the table takes up the full width */\n  }\n\n.graph_two{\n    min-height: 295px;\n}\n\n  \n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
